var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            width: "600px",
            title: _vm.status === "ADD" ? "新增客户" : "编辑客户",
            visible: _vm.dialogFormVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    "label-width": "120px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户类型：", prop: "customerType" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "", placeholder: "请输入" },
                          on: { change: _vm.changeCustomerType },
                          model: {
                            value: _vm.form.customerType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customerType", $$v)
                            },
                            expression: "form.customerType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "常规客户", value: 2 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "小程序客户", value: 3 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "归属客户：", prop: "customer" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择",
                            "value-key": "id",
                          },
                          model: {
                            value: _vm.form.customer,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customer", $$v)
                            },
                            expression: "form.customer",
                          },
                        },
                        _vm._l(_vm.customers, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "归属小程序", prop: "appId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.appId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "appId", $$v)
                            },
                            expression: "form.appId",
                          },
                        },
                        _vm._l(_vm.appOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
              _vm._v(" "),
              _vm.status === "ADD"
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v("去管理员工")]
                  )
                : _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v("确定")]
                  ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }